var locale = {
  // locale: 'zh_CN',
  'DatePicker.placeholder': '请选择日期',
  'DatePicker.yearPlaceholder': '请选择年份',
  'DatePicker.quarterPlaceholder': '请选择季度',
  'DatePicker.monthPlaceholder': '请选择月份',
  'DatePicker.weekPlaceholder': '请选择周',
  'DatePicker.timePlaceholder': '请选择时间',
  'DatePicker.now': '此刻',
  'DatePicker.confrim': '确定',
  'DatePicker.today': '今天',
  'DatePicker.month': '月',
  'DatePicker.year': '年',
  'DatePicker.weekTitle': ['日', '一', '二', '三', '四', '五', '六'],
  // 'DatePicker.backToToday': '返回今天',
  // 'DatePicker.timeSelect': '选择时间',
  // 'DatePicker.dateSelect': '选择日期',
  // 'DatePicker.weekSelect': '选择周',
  // 'DatePicker.clear': '清除',
  // 'DatePicker.month': '月',
  // 'DatePicker.year': '年',
  // 'DatePicker.previousMonth': '上个月 (翻页上键)',
  // 'DatePicker.nextMonth': '下个月 (翻页下键)',
  // 'DatePicker.monthSelect': '选择月份',
  // 'DatePicker.yearSelect': '选择年份',
  // 'DatePicker.decadeSelect': '选择年代',
  // 'DatePicker.yearFormat': 'YYYY年',
  // 'DatePicker.dayFormat': 'D日',
  // 'DatePicker.dateFormat': 'YYYY年M月D日',
  // 'DatePicker.dateTimeFormat': 'YYYY年M月D日 HH时mm分ss秒',
  // 'DatePicker.previousYear': '上一年 (Control键加左方向键)',
  // 'DatePicker.nextYear': '下一年 (Control键加右方向键)',
  // 'DatePicker.previousDecade': '上一年代',
  // 'DatePicker.nextDecade': '下一年代',
  // 'DatePicker.previousCentury': '上一世纪',
  // 'DatePicker.nextCentury': '下一世纪',
  'DatePicker.rangePlaceholder': ['开始日期', '结束日期'],
  'DatePicker.rangeYearPlaceholder': ['开始年份', '结束年份'],
  'DatePicker.rangeMonthPlaceholder': ['开始月份', '结束月份'],
  'DatePicker.rangeWeekPlaceholder': ['开始周', '结束周'],
  'DatePicker.rangeQuarterPlaceholder': ['开始季度', '结束季度'],
  'DatePicker.rangeTimePlaceholder': ['开始时间', '结束时间']
};
export default locale;